import React, { useEffect, useRef, useState } from "react";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import { Box, Typography, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { IoLocationSharp } from "react-icons/io5";

import femaleImg from "../../../images/femaleMatch.png";
import maleImg from "../../../images/maleMatch.png";

export const SliderComponent = ({
  data,
  title,
  matchesType,
  total,
  onViewAllClick,
  onProfileClick,
}) => {
  const sliderRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  const checkScrollPosition = () => {
    const slider = sliderRef.current;
    if (!slider) return;

    const tolerance = 10;

    setAtStart(slider.scrollLeft <= tolerance);
    setAtEnd(
      slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - tolerance,
    );
  };

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const update = () => checkScrollPosition();

    requestAnimationFrame(update); // ensures layout ready
    slider.addEventListener("scroll", update);

    return () => slider.removeEventListener("scroll", update);
  }, [loading]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1200);
  }, [data]);

  const navigate = useNavigate();

  const scroll = (dir) => {
    if (!sliderRef.current) return;

    const amount = dir === "left" ? -320 : 320;
    sliderRef.current.scrollBy({ left: amount, behavior: "smooth" });

    setTimeout(checkScrollPosition, 300);
  };

  // ------------------- FALLBACK LOGIC -------------------

  const getPhoto = (item) => {
    if (item.profilePhoto && item.profilePhoto !== "") {
      return item.profilePhoto;
    }

    if (item.username) {
      return item.username.startsWith("M") ? maleImg : femaleImg;
    }

    return maleImg;
  };


  return (
    <Box
      sx={{
        marginBottom: "30px",
        bgcolor: "#fff",
        padding: "0px 0px 20px 0px",
        borderRadius: "16px",
        boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.2)",
      }}
    >
      {/* ---------------- HEADER ROW ---------------- */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          padding: "12px 22px",
          borderRadius: "16px",
          backgroundColor: "#f1f7fe",
        }}
      >
        <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
          {title}
        </Typography>

        <Tooltip title="Click to view all">
          <Typography
            onClick={() => onViewAllClick(matchesType)}
            sx={{
              color: "#FF5A3C",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
             {total} Profiles
          </Typography>
        </Tooltip>
      </Box>

      {/* ---------------- SLIDER LIST ---------------- */}
      <Box
        ref={sliderRef}
        sx={{
          display: "flex",
          overflowX: "auto",
          gap: "18px",
          paddingBottom: "10px",
          margin: "18px 20px",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {loading
          ? [...Array(3)].map((_, i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width={280}
                height={320}
                sx={{ borderRadius: "35px" }}
              />
            ))
          : data.map((item, index) => (
              <Box
                key={index}
                onClick={() => onProfileClick(item.username)}
                sx={{
                  width: "280px",
                  height: "320px",
                  borderRadius: "35px",
                  overflow: "hidden",
                  position: "relative",
                  flexShrink: 0,
                  cursor: "pointer",
                }}
              >
                {/* ---- BLURRED BACKGROUND LAYER ---- */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url("${getPhoto(item)}")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    filter: "blur(18px)",
                    transform: "scale(1.2)",
                    zIndex: 1,
                  }}
                />

                {/* ---- MAIN IMAGE (CLEAR) ---- */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url("${getPhoto(item)}")`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    zIndex: 2,
                  }}
                />

                {/* ---- GRADIENT + TEXT OVERLAY ---- */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    height: "30%",
                    zIndex: 3,
                    background:
                      "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0, 0, 0, 0.17) 24%, rgba(0, 0, 0, 0.58) 100%)",
                    padding: "18px",
                    color: "#fff",
                  }}
                >
                  {/* Location Row */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      marginBottom: "5px",
                    }}
                  >

                     <Typography sx={{ fontSize: "20px", fontWeight: 600, lineHeight: "1.1" }}>
                      {item.name}
                    </Typography>
                    
                  </Box>

                  {/* Name + Age */}
                  <Box
                    sx={{
                      display: "flex",
                      // justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >

                    {/* <IoLocationSharp size={18} color="white" />
                    <Typography sx={{ fontSize: "16px", fontWeight: 500 , paddingRight: 5}}>
                      {item.residingCity || item.nativeCity || "--"}
                    </Typography> */}

                   {(item.residingCity || item.nativeCity) && (
  <>
    <IoLocationSharp size={18} color="white" />

    <Typography
      sx={{
        fontSize: "16px",
        fontWeight: 500,
        paddingRight: 5,
      }}
    >
      {item.residingCity || item.nativeCity}
    </Typography>
  </>
)}

                    <Typography sx={{ fontSize: "15px", fontWeight: 500 }}>
                      {item.age} years
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
      </Box>

      {/* ---------------- ARROWS + INDICATORS ---------------- */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          margin: "10px 0px",
        }}
      >
        <Box
          onClick={() => !atStart && scroll("left")}
          sx={{
            position: "absolute",
            left: 0,
            padding: "16px",
            cursor: atStart ? "not-allowed" : "pointer",
            opacity: atStart ? 0.3 : 1,
          }}
        >
          <IoMdArrowBack size={20} color="#000" />
        </Box>

        <Box
          onClick={() => !atEnd && scroll("right")}
          sx={{
            position: "absolute",
            right: 0,
            padding: "16px",
            cursor: atEnd ? "not-allowed" : "pointer",
            opacity: atEnd ? 0.3 : 1,
          }}
        >
          <IoMdArrowForward size={20} color="#000" />
        </Box>
      </Box>
    </Box>
  );
};
